import React from 'react'
import PropTypes from 'prop-types'
import TrialLayout from '../TrialLayout/TrialLayout'
import { Row, Col } from 'react-bootstrap'
import messages from './messages'
import LanguageProvider from '../../containers/LanguageProvider/LanguageProvider'
import styled, { withTheme } from 'styled-components'
import { ASSETS_URL } from '../../constants/urls'

const Wrapper = styled.div`
  color: var(--clr-grey-3-to-white);

  a {
    color: var(--clr-accent);
    text-decoration: underline;

    &:hover {
      opacity: 0.5;
    }
  }

  .guide-pre {
    padding-bottom: 35px;
    border-bottom: 1px solid #ddd;
    font-size: var(--h5);
  }

  .example-enter {
    opacity: 0.01;
  }

  .example-enter.example-enter-active {
    opacity: 1;
    transition: opacity 500ms ease-in;
  }

  .guide-body {
    padding-top: 5px;
  }

  .indent {
    padding-left: 45px;
  }

  legend {
    color: var(--clr-grey-3-to-accent);
    font-size: 1.5em;
    margin-top: 0;
    font-weight: bold;
  }

  .trouble-radio-text > label {
    font-weight: normal;
    margin-bottom: 10px;
    cursor: pointer;
    text-decoration: underline;
  }

  .trouble-radio {
    vertical-align: text-top;
    margin-right: 12px;
  }

  .resolved-next {
    height: 120px;
    width: 270px;
  }

  .resolved-back {
    display: flex;
    align-items: flex-end;
    margin-bottom: 12px;
  }

  .resolved-back > .btn-toolbar {
    position: absolute;
    left: 0;
    bottom: -5px;
  }

  .resolved-next {
    background-color: var(--clr-grey-7-to-text);
    padding: 15px 25px 20px 25px;
    text-align: center;
    font-weight: bold;
    border-radius: var(--button-border-radius);
    min-width: 270px;
  }

  .resolved-next span {
    margin-top: 7.5px;
    font-size: var(--h5);
  }

  .btn {
    min-width: 102px;
    min-height: var(--button-height);
    margin: 0 auto;
    font-size: var(--h5);
    font-weight: bold;
    line-height: 2px;
  }

  .btn-back {
    background-color: var(--clr-btn);
    color: var(--clr-text-on-button);
    border-color: var(--clr-btn);
    transition: all 300ms ease-in-out;
    border-radius: var(--button-border-radius);

    &:hover {
      background-color: var(--clr-grey-0-to-text);
      color: var(--clr-black-to-white);
    }
  }

  .btn-resolve {
    color: var(--clr-text-on-button);
    background-color: var(--clr-btn);
    border-color: var(--clr-btn);
    border-radius: var(--button-border-radius);
    margin: 10px 5px;
  }

  .btn-custom-toolbar {
    margin-left: -10px;
    margin-right: -10px;
  }

  .trouble-step-text {
    white-space: pre-wrap;

    p {
      color: var(--clr-grey-3-to-white);
    }
  }

  .trouble-step-text a {
    color: var(--clr-grey-3-to-text);
    text-decoration: underline;
    cursor: pointer;
  }

  .guide-clear {
    clear: both;
  }
`

const proptypes = {
  currentPhone: PropTypes.object,
  relatedType: PropTypes.string.isRequired,
  children: PropTypes.node,
  relatedData: PropTypes.array,
  isFetching: PropTypes.bool,
  noSideBar: PropTypes.bool,
  noSearchBar: PropTypes.bool
}

const Guides = props => {
  const {
    currentPhone,
    children,
    relatedData,
    relatedType,
    isFetching,
    noSideBar,
    noSearchBar,
    name,
    language,
    relatedId
  } = props
  const imageSrc = currentPhone && ASSETS_URL + currentPhone.image_location
  const imageAlt =
    currentPhone && `${currentPhone.manufacturer} ${currentPhone.name}`
  const translated = messages[language]
  const title = name
    ? name
    : translated['guides'] + ` | ${currentPhone && currentPhone.name_pretty}`

  return (
    <TrialLayout
      isFetching={isFetching}
      relatedData={relatedData}
      contentType="guide"
      relatedType={relatedType}
      relatedId={relatedId}
      noSideBar={noSideBar}
      noSearchBar={noSearchBar}
      title={title}
    >
      <Wrapper>
        <Row className="guide-body">
          <Col xs={12} sm={12} md={3}>
            <img src={imageSrc} alt={imageAlt} width={120} />
          </Col>
          <Col xs={12} sm={12} md={9}>
            <Row>{children}</Row>
          </Col>
        </Row>
      </Wrapper>
    </TrialLayout>
  )
}

Guides.propTypes = proptypes

export default LanguageProvider(withTheme(Guides))



// WEBPACK FOOTER //
// ./src/components/Guides/Guides.js